<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Trackinglist-Vorlage erstellen</h2>
        <div class="input-row" style="margin-bottom: 4px">
            <inputFloatLabel style="width: 100%;margin-right: 4px" label="Vorlagenname" @input="moduleNameChanged"
                             :value="moduleName"></inputFloatLabel>
        </div>
        <div class="item-row" style="margin-bottom: 4px">
            <InputFloatLabel style="width: 200px"
                             class="setupInfos" icon-size="2.4em" :value="this.deviceType" label="Mediumbezeichnung"
                             :icon="this.deviceMapping[this.deviceType]['icon']" iconColor="#D70465"
                             @click="this.toggleDevice"
                             @input="deviceInput">
            </InputFloatLabel>
            <div class="add-buttons">
                <AdaButton style="margin-right: 10px" :custom-styles="addModuleStyles" title="SPACE-VORLAGE LADEN"
                           @click="openAddSpacesDialog" type="createButton" icon="icon-load"></AdaButton>
            </div>

        </div>
        <AdaDatatable :columns="columns" :data="[]" :show-pagination="false"
                      :show-search="false"
                      :size-of-page="100">
        </AdaDatatable>
        <div class="space-container" v-for="(space,index) in filteredSpaces" v-bind:key="space.id">
            <TrackingListSpaceElement @moveUp="moveUp(index)" @moveDown="moveDown(index)" @onDelete="deleteSpace(space)"
                                      :space="space" :interactions="space.filteredInteractions"
                                      :technical-name="space.technical_name" :widths="columns"></TrackingListSpaceElement>
        </div>
        <AdaButton icon="icon-add" @click="openAddSpacesDialog" type="fullWidthButton"
                   title="SPACE HINZUFÜGEN"></AdaButton>
        <div style="margin-top: 20px">
            <AdaButton :loading="savingTemplate" style="width: 300px; height: 40px" title="TRACKING-LISTE SPEICHERN"
                       @click="createClicked"
                       type="createButton"></AdaButton>
        </div>
        <Dialog v-if="showAddSpacesDialog" :show-close-button="true" :show="showAddSpacesDialog"
                :has-backdrop="true" width="80%" max-width="1200px"
                @close="closeAddSpacesDialog">
            <SelectSpacesFromTable :initial-spaces="filteredSpaces" :force-reload="true"
                                   @selected="spacesSelected"></SelectSpacesFromTable>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import AdaButton from "../../../components/buttons/AdaButton";
    import Dialog from "../../../components/dialog/Dialog";
    import Transformers from "../../../components/tables/Transformers";
    import SelectSpacesFromTable from "../spaces/SelectSpacesFromTable";
    import TrackingListSpaceElement from "./TrackingListSpaceElement";

    const TrackingListsRepository = RepositoryFactory.get('trackingLists');

    export default {
        components: {
            TrackingListSpaceElement,
            SelectSpacesFromTable,
            BreadCrumb,
            AdaDatatable,
            InputFloatLabel,
            AdaButton,
            Dialog,
        },
        data: function () {
            return {
                addModuleStyles: {
                    'background-color': '#00b6ed',
                    'border-color': '#00b6ed'
                },
                spaces: [],
                filteredSpaces: [],
                deviceType: 'Online',
                deviceMapping: {
                    'Online': {
                        'icon': 'icon-device-xdigital'
                    },
                    'Desktop': {
                        'icon': 'icon-device-desktop'
                    },
                    'Mobile': {
                        'icon': 'icon-device-mobile'
                    },
                    'Tablet': {
                        'icon': 'icon-device-tablet'
                    }
                },
                showAddSpacesDialog: false,
                moduleName: '',
                columns: [
                    {
                        viewName: 'Interaction Name',
                        propName: 'name',
                        sortable: true,
                        width: '25%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        width: '25%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '10%'
                    },
                    {
                        viewName: 'Beschreibung',
                        propName: 'description',
                        width: '40%'
                    }
                ],
                transformers: [
                    {
                        propName: 'target_medium',
                        transform: Transformers.spaceModuleMediumTransformer
                    },
                    {
                        propName: 'action',
                        transform: Transformers.actionTransformer
                    }
                ],
                savingTemplate: false,
                fn: null
            }
        },
        name: "CreateTrackingListTemplate",
        mounted() {
            this.fn = () => {
                this.createClicked(true);
            };
            this.$root.$on('saveCreateTrackinglist', this.fn);
        },
        beforeDestroy() {
            this.$root.$off('saveCreateTrackinglist', this.fn);
        },
        watch: {
            spaces(newVal) {
                this.filterSpacesByType(newVal);
            },
            deviceType() {
                this.filterSpacesByType(this.spaces);
            }
        },
        methods: {
            arrayMove(array, from, to) {
                array.splice(to, 0, array.splice(from, 1)[0]);
            },
            moveUp(index) {
                if (index > 0) {
                    this.arrayMove(this.filteredSpaces, index, index - 1);
                }
            },
            moveDown(index) {
                if (index < this.filteredSpaces.length - 1) {
                    this.arrayMove(this.filteredSpaces, index, index + 1);
                }
            },
            isInteractionValid(inter) {
                let valid = false;
                switch (this.deviceType.toLowerCase()) {
                    case "online":
                        valid = true;
                        break;
                    case "desktop":
                        if (inter.on_desktop === 1) {
                            valid = true;
                        }
                        break;
                    case "mobile":
                        if (inter.on_mobile === 1) {
                            valid = true;
                        }
                        break;
                    case "tablet":
                        if (inter.on_tablet === 1) {
                            valid = true;
                        }
                        break;
                }
                return valid;
            },
            filterSpacesByType(spaces) {
                this.filteredSpaces.length = 0;
                for (let i = 0; i < spaces.length; i++) {
                    let space = spaces[i];
                    this.filteredSpaces.push(space);
                    let filteredInteractions = [];
                    for (let j = 0; j < spaces[i].interactions.length; j++) {
                        let inter = spaces[i].interactions[j];
                        if (this.isInteractionValid(inter)) {
                            filteredInteractions.push(inter);
                        }
                    }
                    for (let j = 0; j < spaces[i].modules.length; j++) {
                        let module = spaces[i].modules[j];
                        let filteredModuleInteractions = [];
                        for (let k = 0; k < module.interactions.length; k++) {
                            let inter = module.interactions[k];
                            if (this.isInteractionValid(inter)) {
                                filteredModuleInteractions.push(inter);
                            }
                        }
                        module.filteredInteractions = filteredModuleInteractions;
                    }
                    space.filteredInteractions = filteredInteractions;
                }
            },
            openAddSpacesDialog() {
                this.showAddSpacesDialog = true;
            },
            createClicked(clickedFromHeader = false) {
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', true) : this.savingTemplate = true;
                this.createTrackingList(clickedFromHeader);
            },
            async createTrackingList(clickedFromHeader) {
                try {
                    const json = {
                        name: this.moduleName,
                        target_medium: this.deviceType,
                        spaceIds: this.filteredSpaces.map(space => space.id),
                        is_template: 1
                    };
                    await TrackingListsRepository.createTrackingList(json);
                    this.$noty.success("Die Trackinglist-Vorlage wurde erfolgreich erstellt!");
                    await this.$router.push({name: 'templatetrackinglists'});
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Erstellung der Trackinglits-Vorlage: " + e);
                }
                clickedFromHeader ? this.$root.$emit('trackinglistLoader', false) : this.savingTemplate = false;
            },
            deleteSpace(space) {
                this.spaces.splice(this.spaces.indexOf(space), 1);
            },
            spacesSelected(selectedSpaces) {
                this.spaces = selectedSpaces;
                this.spaces.forEach((space, index) => {
                    space.hide = index !== 0;
                    space.modules.forEach(mod => {
                        mod.hide = true;
                    });
                    space.interactions.sort(this.sortByPivot);
                    space.modules.sort(this.sortByPivot);
                    space.modules.forEach((module)=>{
                        if(module.interactions.length !== 0){
                            module.interactions.sort(this.sortByPivot);
                        }
                    });
                });
                this.showAddSpacesDialog = false;
            },
            sortByPivot(a, b) {
                if (a.pivot.sort < b.pivot.sort) {
                    return -1;
                }
                if (a.pivot.sort > b.pivot.sort) {
                    return 1;
                }
                return 0;
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.$router.push({name: 'editModule', params: {id: data.row.id}});
                        break;
                    case 'duplicate':
                        this.copyClicked(data.row);
                        break;
                    case 'delete':
                        this.filteredSpaces.splice(this.interactions.indexOf(data.row), 1);
                        for (let i = 0; i < this.spaces.length; i++) {
                            if (this.spaces[i].id === data.row.id) {
                                this.spaces.splice(i, 1);
                                break;
                            }
                        }
                        break;
                }
            },
            moduleNameChanged(val) {
                this.moduleName = val;
            },
            closeAddSpacesDialog() {
                this.showAddSpacesDialog = false;
            },
            toggleDevice: function () {
                switch (this.deviceType.toLowerCase()) {
                    case 'online':
                        this.deviceType = 'Desktop';
                        break;
                    case 'desktop':
                        this.deviceType = 'Mobile';
                        break;
                    case 'mobile':
                        this.deviceType = 'Tablet';
                        break;
                    case 'tablet':
                        this.deviceType = 'Online';
                        break;
                }
            },
            deviceInput: function () {
            }
        }
    }
</script>

<style lang="scss" scoped>

    .input-row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .item-row {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        margin-bottom: 10px;
        background-color: white;
        padding: 10px;
        justify-content: space-between;
    }

    .module-container {
        border-bottom: solid 1px $grey;
        border-top: solid 1px $grey;
    }

    .space-container {
        position: relative;
    }

    .add-buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        ::v-deep .createButtons {
            padding: 6px 10px !important;
        }
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }

</style>